import { Component, OnInit, ViewChild } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';

import { EstimatePrototyp } from '../../assets/shared/estimate.object';

@Component({
  selector: 'rcs-modal-estimateline',
  templateUrl: 'rcs-modal-estimateline.html'
})
export class RcsModalEstimateline implements OnInit{

  private estimate_element:any;
  private estimate_form:FormGroup;
  public error_msg: string;
  private autofocus: Boolean = false;
  @ViewChild('nameInput') nameInput;

  constructor(
    private view_controller: ViewController,
    private params: NavParams,
    private formBuilder: FormBuilder ){
      this.estimate_form = this.formBuilder.group({
        name: ['', Validators.required],
        dauer: ['', Validators.required],
      });
    }

  ngOnInit(){
    if (this.params.get('estimate')){
      this.estimate_element = this.params.get('estimate');
      var n = new Date(0, 0);
      n.setMinutes(+this.estimate_element.dauer * 60);
      this.estimate_element.dauer = n.toTimeString().slice(0, 5);
    }else{
      this.estimate_element = new EstimatePrototyp();
      this.estimate_element.dauer = '00:00';
      this.autofocus = true;
    }
  }

  ngAfterViewChecked() {
    if (this.autofocus) {
      this.nameInput.setFocus();
    }
  }

  public submit(prototyp:any){
    let results = this.estimate_form.value;
    this.estimate_element.name = results.name;
    this.estimate_element.price_unit = results.price_unit;
    this.estimate_element.dauer = results.dauer;

    let estimate_element = this.validate_prototyp(prototyp);
    if (estimate_element.dauer > 0){
      this.view_controller.dismiss({'estimate': estimate_element});
    }else{
      this.error_msg = 'Die Dauer darf nicht 0 betragen!';
    }
  }

  public abort(prototyp:any){
    this.view_controller.dismiss();
  }

  private validate_prototyp(estimate:any){
    const time = estimate.dauer.split(':');
    estimate.dauer = parseFloat(time[0]) + (time[1] / 60);
    return estimate;
  }

}



// WEBPACK FOOTER //
// ./src/components/rcs-modal-estimateline/rcs-modal-estimateline.ts